import ImageLoader from "@client/controls/Image/Loader/component";
import { withDynamicOptionsAdapterHOC } from "@client/hocs/withDynamicOptions";
import {
  DynamicRadioButtonGroup as DynamicRadioButtonGroupCommon,
  FormRadioButtonGroup,
  RadioButtonGroup as RadioButtonGroupCommon,
  type RadioButtonGroupProps as RadioButtonGroupPropsCommon,
  type RadioOptionItem
} from "@common/controls/Inputs/Radio/index";
import React from "react";

import "./style.less";

export const DynamicRadioButtonGroup = withDynamicOptionsAdapterHOC(DynamicRadioButtonGroupCommon);
export { type RadioOptionItem };

export { FormRadioButtonGroup, RadioButtonGroupCommon };

export type RadioButtonGroupProps = Omit<RadioButtonGroupPropsCommon, "ImageComponent">;
const RadioButtonGroup = (props: RadioButtonGroupProps) => (
  <RadioButtonGroupCommon {...props} ImageComponent={ImageLoader} />
);

export default RadioButtonGroup;
